window.app = {
	breakpoins: {
		sm: 576,
		md: 800,
		lg: 1024,
		xl: 1199,
	},
};

import '../css/tailwind.css';

import { createApp } from 'vue';
import YandexMap from './components/YandexMap.vue';

if(window.ADDRESS) {
    createApp(YandexMap, {address: window.ADDRESS}) // передаём из Blade
        .mount('#app');
}
